class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;
// old //
  // connectedCallback() {
  //   this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  //     if (event.source === 'cart-items') {
  //       return;
  //     }
  //     return this.onCartUpdate();
  //   });
  // }
// old//
  connectedCallback() {
  this.cartUpdateUnsubscriber = subscribe(
    PUB_SUB_EVENTS.cartUpdate,
    event => {
      // Prevent self-trigger loop
      if (event.source === this.tagName.toLowerCase()) return;

      this.onCartUpdate();
    }
  );
}

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }
          

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
// old //

// if (parsedState.item_count === 0) {
//   refreshCartDrawerEmptyState();
//   forceUpdateCartCount(0);
//   return;
// }

// old //
// 000000000000000000000000000000 //
if (parsedState.item_count === 0) {
  refreshCartDrawerEmptyState();
  refreshCartPageEmptyState(); // 👈 ADD THIS
  forceUpdateCartCount(0);
}
// 000000000000000000000000000000 //


if (parsedState.item_count === 0) {
  refreshCartDrawerEmptyState();
  refreshCartPageEmptyState();
  forceUpdateCartCount(0);
}




          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
// old //
          // this.getSectionsToRender().forEach((section) => {
          //   const elementToReplace =
          //     document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          //   elementToReplace.innerHTML = this.getSectionInnerHTML(
          //     parsedState.sections[section.section],
          //     section.selector
          //   );
          // });
// old //
this.getSectionsToRender().forEach((section) => {
  const sectionElement = document.getElementById(section.id);
  if (!sectionElement) return;

  const elementToReplace =
    sectionElement.querySelector(section.selector) || sectionElement;

  elementToReplace.innerHTML = this.getSectionInnerHTML(
    parsedState.sections[section.section],
    section.selector
  );
});

/* ===============================
   FORCE CART DRAWER EMPTY STATE
================================ */
// const cartDrawer = document.querySelector('cart-drawer');

// if (cartDrawer && parsedState.item_count === 0) {
//   fetch(`${routes.cart_url}?section_id=cart-drawer`)
//     .then((res) => res.text())
//     .then((htmlText) => {
//       const html = new DOMParser().parseFromString(htmlText, 'text/html');

//       const newDrawerItems = html.querySelector('cart-drawer-items');
//       const newDrawerFooter = html.querySelector('.cart-drawer__footer');

//       const currentDrawerItems = document.querySelector('cart-drawer-items');
//       const currentDrawerFooter = document.querySelector('.cart-drawer__footer');

//       if (newDrawerItems && currentDrawerItems) {
//         currentDrawerItems.replaceWith(newDrawerItems);
//       }

//       if (newDrawerFooter && currentDrawerFooter) {
//         currentDrawerFooter.replaceWith(newDrawerFooter);
//       }

//       cartDrawer.classList.add('is-empty');
//     });
// }
// new //
          // const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          // let message = '';
          // if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          //   if (typeof updatedValue === 'undefined') {
          //     message = window.cartStrings.error;
          //   } else {
          //     message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          //   }
          // }
          const updatedValue = parsedState.items[line - 1]? parsedState.items[line - 1].quantity: undefined;
let message = '';
if (typeof updatedValue !== 'undefined') {
  quantityElement.value = updatedValue;
  quantityElement.setAttribute('value', updatedValue);
  if (updatedValue !== parseInt(quantity)) {
    message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
  }
}
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
    
forceUpdateCartCount(parsedState.item_count);


      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}


// add by me //
// function forceUpdateCartCount(itemCount) {
//   const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
//   if (!bubble) return;

//   const number = bubble.querySelector('[aria-hidden="true"]');
//   if (number) number.textContent = itemCount;

//   if (itemCount === 0) {
//     bubble.classList.add('hidden');
//   } else {
//     bubble.classList.remove('hidden');
//   }
// }
function forceUpdateCartCount(itemCount) {
  const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
  if (!bubble) return;

  const number = bubble.querySelector('[aria-hidden="true"]');
  if (number) number.textContent = itemCount;

  if (itemCount === 0) {
    bubble.classList.add('hidden');
  } else {
    bubble.classList.remove('hidden');
  }
  refreshCartDrawer();
}


// function forceUpdateCartCount(itemCount) {
//   const bubbleWrapper = document.querySelector('#cart-icon-bubble');
//   if (!bubbleWrapper) return;

//   const countBubble = bubbleWrapper.querySelector('.cart-count-bubble');
//   const hiddenCount = bubbleWrapper.querySelector('[aria-hidden="true"]');
//   const visibleCount = bubbleWrapper.querySelector('.cart-count-bubble span');

//   /* Update numbers */
//   if (hiddenCount) hiddenCount.textContent = itemCount;
//   if (visibleCount) visibleCount.textContent = itemCount;

//   /* Dawn behavior: hide ONLY the count bubble */
//   if (countBubble) {
//     if (itemCount === 0) {
//       countBubble.classList.add('hidden');
//     } else {
//       countBubble.classList.remove('hidden');
//     }
//   }
// }

// -----------------//
function refreshCartDrawerEmptyState() {
  const cartDrawer = document.querySelector('cart-drawer');
  const cartBubble = document.querySelector('#cart-icon-bubble');

  fetch('/?sections=cart-drawer,cart-icon-bubble')
    .then(res => res.json())
    .then(sections => {
      /* -------- CART DRAWER -------- */
      if (cartDrawer && sections['cart-drawer']) {
        const html = new DOMParser().parseFromString(
          sections['cart-drawer'],
          'text/html'
        );
        const freshDrawer = html.querySelector('cart-drawer');

        if (freshDrawer) {
          cartDrawer.innerHTML = freshDrawer.innerHTML;
          cartDrawer.classList.add('is-empty');
        }
      }

      /* -------- CART ICON COUNT -------- */
      if (cartBubble && sections['cart-icon-bubble']) {
        const bubbleHTML = new DOMParser().parseFromString(
          sections['cart-icon-bubble'],
          'text/html'
        );
        const freshBubble = bubbleHTML.querySelector('#cart-icon-bubble');

        if (freshBubble) {
          cartBubble.replaceWith(freshBubble);
        }
      }

      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('drawer-open');
    });
}

// add by me //


// 0000000000000000000000000000000000000//

function refreshCartDrawer() {
  fetch('/?sections=cart-drawer,cart-icon-bubble')
    .then(res => res.json())
    .then(sections => {

      const drawer = document.querySelector('cart-drawer');

      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents({
          sections: sections
        });
      }

      // 🔥 Manually update cart icon bubble (IMPORTANT)
      const bubbleSection = document.getElementById('shopify-section-cart-icon-bubble');
      if (bubbleSection && sections['cart-icon-bubble']) {
        bubbleSection.innerHTML = sections['cart-icon-bubble'];
      }

      if (drawer) drawer.open();
    });
}


function refreshCartPageEmptyState() {
  const cartItems = document.querySelector('cart-items');
  const cartFooter = document.getElementById('main-cart-footer');

  fetch(`${routes.cart_url}?section_id=main-cart-items`)
    .then(res => res.text())
    .then(htmlText => {
      const html = new DOMParser().parseFromString(htmlText, 'text/html');
      const freshCartItems = html.querySelector('cart-items');

      if (cartItems && freshCartItems) {
        cartItems.innerHTML = freshCartItems.innerHTML;
        cartItems.classList.add('is-empty');
      }

      if (cartFooter) {
        cartFooter.classList.add('is-empty');
      }
    });
}



// 00000000000000000000000000 //